import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroImage, valueStack } from '../data/copy';
const badges = ['Immediate access', 'Secure payment', '7-day guarantee'];
export function OfferSection() {
  return <section id="offer" className="w-full scroll-mt-6 bg-charcoal py-10 sm:py-12" aria-labelledby="offer-heading" data-id="element-95" data-mp="8llss715ftfz">
      <div className="mx-auto max-w-xl px-6" data-id="element-96" data-mp="idzwv6fp9c5b">
        <div className="text-center" data-id="element-97" data-mp="icyhwqvkc5ib">
          <p className="eyebrow text-rose" data-id="element-98" data-mp="mejwcgnqwrum">The complete package</p>
          <h2 id="offer-heading" className="mx-auto mt-3 max-w-md font-display text-3xl leading-tight text-cream sm:text-4xl" data-id="element-99" data-mp="mgwk5ag6pwfl">
            Everything You Need For Your Next Class
          </h2>
        </div>

        <div className="mt-7 rounded-4xl border border-gold/40 bg-cream p-5 shadow-soft sm:p-7" data-id="element-100" data-mp="2t62swlvzgm8r">
          <div className="rounded-3xl bg-blush px-4 py-3" data-id="element-101" data-mp="2y3umdkca0gf2">
            <img src={heroImage} alt="Everything included: the 6 master volumes, 7 bonus books and printable planners." className="mx-auto w-full max-w-[260px]" width={1240} height={1240} loading="lazy" data-id="element-102" data-mp="2y67bchggbr1m" />
          </div>

          <ul className="mt-6" data-id="element-103" data-mp="ow3p502r1kfk">
            {valueStack.map(line => <li key={line.label} className="flex items-baseline justify-between gap-4 border-b border-charcoal/10 py-2.5" data-id="element-104" data-mp="ou0to0ituz3g">
                <span className="font-sans text-[0.8rem] leading-snug text-ash" data-id="element-105" data-mp="1gokxbsiy7c1r">
                  {line.label}
                </span>
                <span className="font-display text-lg text-rose-deep line-through" data-id="element-106" data-mp="1cnj0fici7c2y">
                  {line.value}
                </span>
              </li>)}
            <li className="flex items-baseline justify-between gap-4 py-3" data-id="element-107" data-mp="184147wto84o">
              <span className="eyebrow text-charcoal/70" data-id="element-108" data-mp="3sbsqbs7ws77z">Total value</span>
              <span className="font-display text-2xl text-charcoal line-through decoration-rose-deep" data-id="element-109" data-mp="3tu9abacuhhjc">
                $324
              </span>
            </li>
          </ul>

          <div className="mt-2 rounded-3xl border border-gold/40 bg-blush px-6 py-6 text-center" data-id="element-110" data-mp="2lc5lpo2elf2">
            <p className="eyebrow text-gold" data-id="element-111" data-mp="3kvnqlbvmzwgz">Your price today</p>
            <p className="mt-1 flex items-start justify-center gap-1 font-display text-[4.5rem] leading-none text-wine" data-id="element-112" data-mp="3otbq6s89ydf7">
              <span className="mt-3 text-2xl" data-id="element-113" data-mp="3b1f4b5x78zr9">$</span>27
            </p>
            <p className="mt-3 inline-block rounded-full bg-wine px-4 py-1.5 font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-cream" data-id="element-114" data-mp="3fv03h1aj3zs1">
              73% off launch special
            </p>
          </div>

          <CtaButton href="#offer" className="mt-5 w-full py-5" data-id="element-115" data-mp="362c7u9vac1uw">
            Get instant access — $27
          </CtaButton>

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-116" data-mp="2x3qquj5gouw8">
            {badges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-ash" data-id="element-117" data-mp="2dh5ia3nno03f">
                <CheckCircle2Icon className="h-3.5 w-3.5 text-gold" strokeWidth={1.7} aria-hidden="true" data-id="element-118" data-mp="28kyfukugx6q8" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}